import type { ReportData, ReportIntakeCard } from '@/lib/types';

interface IntakeTabProps {
  report: ReportData;
  intake: ReportIntakeCard[];
}

export function IntakeTab({ report, intake }: IntakeTabProps) {
  return (
    <div className="flex flex-col gap-3.5">
      {/* Patient summary */}
      <section className="glass-panel px-7 py-6 max-[760px]:p-5">
        <h3 className="text-[11px] font-semibold tracking-[0.06em] uppercase text-muted m-0 mb-4">
          Información del paciente
        </h3>
        <dl className="grid grid-cols-3 gap-x-6 gap-y-4 m-0 max-[760px]:grid-cols-2">
          <Field label="Nombre" value={report.patientName} />
          <Field label="Edad" value={`${report.patientAge} años`} />
          <Field label="Sexo" value={report.patientGender} />
          <Field label="Ciudad" value={report.patientCity} />
          <Field label="Fecha de captura" value={report.collectedAt} />
          <Field label="ID de reporte" value={report.id} mono />
        </dl>
      </section>

      {/* Intake cards */}
      <div className="grid grid-cols-2 gap-2.5 max-[760px]:grid-cols-1">
        {intake.map((card) => (
          <article
            key={card.category}
            className="glass-panel p-5 px-[22px] flex flex-col gap-3"
          >
            <h3 className="text-[13px] font-semibold tracking-[-0.005em] m-0 flex items-baseline justify-between">
              <span>{card.category}</span>
              <span className="text-[10px] font-medium tracking-[0.04em] uppercase text-muted">
                {card.answers.length} respuesta{card.answers.length === 1 ? '' : 's'}
              </span>
            </h3>
            <dl className="m-0 flex flex-col">
              {card.answers.map((a, i) => (
                <div
                  key={a.question}
                  className={`flex items-baseline justify-between gap-3 py-1.5 ${
                    i < card.answers.length - 1 ? 'border-b border-line-glass' : ''
                  }`}
                >
                  <dt className="text-[12px] text-tertiary m-0">{a.question}</dt>
                  <dd className="text-[12.5px] font-medium text-secondary text-right m-0">
                    {a.answer}
                  </dd>
                </div>
              ))}
            </dl>
          </article>
        ))}
      </div>
    </div>
  );
}

interface FieldProps {
  label: string;
  value: string;
  mono?: boolean;
}

function Field({ label, value, mono }: FieldProps) {
  return (
    <div>
      <dt className="text-[10px] font-semibold tracking-[0.06em] uppercase text-muted m-0 mb-1">
        {label}
      </dt>
      <dd className={`text-[13.5px] font-medium text-primary m-0 ${mono ? 'tnum tracking-[0.005em]' : ''}`}>
        {value}
      </dd>
    </div>
  );
}
